import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SchemaIcon(props: IconProps) {
    return <Icon {...props} iconKey={"schema"}/>
}
